<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <InfectedFileDialog :file-name="dialogProps.fileName"
                          :file-uid="dialogProps.fileUid"
                          :is-template="dialogProps.isTemplate"
                          :is-client-initiated="dialogProps.isClientInitiated"
                          @close="handleClose"
                          @failure="handleClose(true)"
                          @success="handleSubmit"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import InfectedFileDialog from "../components/InfectedFileDialog";

export default {
  name: "InfectedFile",
  components: {FullscreenFrontageDialog, InfectedFileDialog},
  methods: {
    handleClose(isFailure) {
      this.$refs.frontageDialog.handleClose(isFailure);
    },
    handleSubmit() {
      this.$refs.frontageDialog.handleSubmit();
    }
  }
}
</script>
